export default function ({ store, redirect, error, route }) {
    if (!store.getters.user) {
        return redirect(`/login?r=${route.path}`)
    }
    if (!store.getters.canBroker) {
        return error({ statusCode: 401, message: 'You are not authorized to access this page' })
    }
}
